import SectionWithTitle from './SectionWithTitle';

export default SectionWithTitle;
